export default "__VITE_ASSET__Bm3AGQ53__"